import { render, staticRenderFns } from "./SellerMapping.vue?vue&type=template&id=2e28f8c8&"
import script from "./SellerMapping.vue?vue&type=script&lang=js&"
export * from "./SellerMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports